import React from 'react'
import { Actions, StyledButton } from './ArcAdvertisers.styles'

export const getColumns = (handleEditAdvertiser) => [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    sorter: true,
    width: 80,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: true,
    filterable: true,
  },
  {
    title: 'Created Date',
    dataIndex: 'created_at',
    key: 'created_at',
    sorter: true,
    width: 180,
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 170,
    render: (_, record) => {
      const onEdit = () => handleEditAdvertiser(record)
      return (
        <Actions>
          <StyledButton onClick={onEdit}>Edit</StyledButton>
        </Actions>
      )
    },
  },
]